import { ReactElement } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { RequiredAuth } from "routes/required-auth";
import { SigninOIDC } from "scenes/authentications/signin-oidc";
import { Logout } from "scenes/authentications/logout";
import { LogoutCallback } from "scenes/authentications/logout-callback";
import { SilentRenew } from "scenes/authentications/silent-renew";
import ScrollToTop from "../components/scroll-to-top";
import Homepage from "../scenes/homepage";
import Register from "../scenes/register";
import RedirectApp from "scenes/redirectApp";
import CheckoutScene from "../scenes/checkout";
import ProgramScene from "../scenes/programs";
import PayScene from "../scenes/pay";

const Router = (): ReactElement => {

    return (
        <BrowserRouter>
            <ScrollToTop>
                <Routes>
                    <Route path="/signin-oidc" element={<SigninOIDC />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/logout/callback" element={<LogoutCallback />} />
                    <Route path="/silentrenew" element={<SilentRenew />} />

                    {/*<Route path='/profile' element={<RequiredAuth><ProfileScene /></RequiredAuth>} />*/}
                    {/*<Route path='/profile/edit' element={<RequiredAuth><ProfileEditScene /></RequiredAuth>} />*/}
                    <Route path="/" element={<Homepage />} />
                    {/*<Route path="/" element={<RedirectApp />} />*/}

                    <Route path="/register" element={<Register />} />
                    <Route path="/checkout/:programId" element={<CheckoutScene />} />
                    <Route path="/pay/:invoiceNo" element={<PayScene />} />

                    <Route path="/programs" element={<ProgramScene />} />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </ScrollToTop>
        </BrowserRouter>
    );
}

export default Router;
